import { useEffect, useState } from "react";
import { _PaymentFile } from "../../../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectProcessTypeConstants } from "../../../bpm/config/Componentes/SelectProcessTypeConstants";
import { BasicButton } from "../../../theme/Component/BasicButton";


export const PaymentFile = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_PaymentFile);
    const modal = useModal(`Asignaciones de ${bean.TechnicianName}`, MODAL_md);
    const modalDelete = useModal(`Historial de Mantenimientos de ${bean.TechnicianName}`, MODAL_SM);
    const [processType, setProcessType] = useState<number>()

    const getLista = () => {
        instance.getPaymentFileCatalogByProcessType(processType).then(
            (resp: any) => {
                setLista(resp)
            }).catch(err => {
                toast.error(err);
            });
    };


    const create = () => {
        setBean({});
        modal.setModal({ ...modal.modal, view: true, name: "Agregar Tipo de Archivo" });
    }

    const deleteItem = () => {
        instance.deletePaymentFile(bean.IDPaymentFile).then(
            (resp) => {
                getLista();
                modalDelete.close();
            }
        ).catch(err => { toast.error(err) })
    };

    const editaItem = () => {
        instance.updatePaymentFile(bean).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDPaymentFile', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.setModal({ ...modal.modal, view: true, name: "Editar Tipo de Archivo" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Tipos de Archivos de Pago de Cuentas por Pagar">
            <div className="row">
                <div className="col-md-6">
                    <SelectProcessTypeConstants idSelector={processType} onChange={(e) => { setProcessType(e) }} lable="Tipo de Proceso" />
                </div>
                <div className="col-md-2">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Código</label>
                                <input type="text" className="form-control" value={bean.Code} onChange={(e) => { setBean({ ...bean, Code: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <SelectProcessTypeConstants idSelector={bean.ProcessType} onChange={(e) => { setBean({ ...bean, ProcessType: e }) }} lable="Tipo de Proceso" />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.IDPaymentFile}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}